var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.3,188.3l-120,120c-15.6,15.6-41,15.6-56.6,0-15.6-15.6-15.6-41,0-56.6l51.7-51.6H40.1C18,200,0,182.1,0,160s17.9-40,40-40h463.3l-51.7-51.7c-15.6-15.6-15.6-41,0-56.6,15.6-15.6,41-15.6,56.6,0l120,120c15.6,15.6,15.6,41,0,56.6ZM131.7,628.2L11.7,508.2c-15.6-15.6-15.6-41,0-56.6l120-120c15.6-15.6,41-15.6,56.6,0s15.6,41,0,56.6l-51.6,51.7h463.3c22.1,0,40,17.9,40,40s-17.9,40-40,40H136.7l51.7,51.7c15.6,15.6,15.6,41,0,56.6-15.6,15.6-41,15.6-56.6,0h-.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.1c933625265a7e71135484440729f609.svg";
export { ForwardRef as ReactComponent };